import axios from "@/api/config_php";

export const remittanceVoucherList = param =>
  axios.get(`/amp/api/v1/remittanceVoucher/lists`, { params: param });
export const remittanceVoucherInsert = param =>
  axios.post(`/amp/api/v1/remittanceVoucher/insert`, param);
export const remittanceVoucherWithdraw = param =>
  axios.post(`/amp/api/v1/remittanceVoucher/withdraw`, param);
export const remittanceVoucherExport = param =>
  axios.post(`/amp/api/v1/remittanceVoucher/generateRemittanceVoucher`, param);
export const contractDownload = param =>
  axios.get(`/amp/api/v1/client/contractDownload`, { params: param });

//获取汇款账户
export const getVirtualBankAccount = param =>
  axios.get(`/amp/api/v1/VirtualBankAccount/getVirtualBankAccount`, param);
